// 0: sắp tới; 1: đang diễn ra; 2: đã diễn ra || quá hạn; 3: đã hủy
export function transHeadCells(headcells, t) {
    return headcells.map(cell => {
        return {
            ...cell,
            label: t(cell.label)
        }
    })
}